import { computed } from "vue";
import {
    addressLine1Rule,
    addressLine2Rule,
    addressLine3Rule,
    addressLine4Rule,
    addressLine5Rule,
    postcodeRule,
} from "@/validation";

export const findAddressRules = () =>
    computed(() => ({
        line1: addressLine1Rule,
        line2: addressLine2Rule,
        line3: addressLine3Rule,
        line4: addressLine4Rule,
        line5: addressLine5Rule,
        postcode: postcodeRule,
    }));
